import { useEffect, useRef } from "react";

const GOLD = "#C9A84C";

export default function MeshGradient() {
  const ref = useRef<HTMLDivElement>(null);

  // Subtle mouse parallax on blobs
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const onMove = (e: MouseEvent) => {
      const { innerWidth: w, innerHeight: h } = window;
      const x = (e.clientX / w - 0.5) * 30;
      const y = (e.clientY / h - 0.5) * 30;
      el.style.transform = `translate(${x}px, ${y}px)`;
    };
    window.addEventListener("mousemove", onMove, { passive: true });
    return () => window.removeEventListener("mousemove", onMove);
  }, []);

  return (
    <div
      ref={ref}
      aria-hidden
      className="absolute inset-0 pointer-events-none overflow-hidden"
      style={{ transition: "transform 0.15s ease-out", zIndex: 1 }}
    >
      {/* Blob 1 — top-left, gold */}
      <div
        className="mesh-blob mesh-blob-1"
        style={{
          position: "absolute",
          width: 520,
          height: 520,
          top: "-120px",
          left: "-100px",
          borderRadius: "60% 40% 70% 30% / 50% 60% 40% 50%",
          background: `radial-gradient(ellipse at center, ${GOLD}28 0%, ${GOLD}08 55%, transparent 80%)`,
          filter: "blur(48px)",
          animation: "blobMorph1 12s ease-in-out infinite alternate",
        }}
      />

      {/* Blob 2 — bottom-right, blue-ish */}
      <div
        className="mesh-blob mesh-blob-2"
        style={{
          position: "absolute",
          width: 600,
          height: 600,
          bottom: "-180px",
          right: "-120px",
          borderRadius: "40% 60% 30% 70% / 60% 40% 70% 30%",
          background: "radial-gradient(ellipse at center, rgba(99,102,241,0.18) 0%, rgba(139,92,246,0.08) 50%, transparent 80%)",
          filter: "blur(56px)",
          animation: "blobMorph2 15s ease-in-out infinite alternate",
        }}
      />

      {/* Blob 3 — center, subtle gold */}
      <div
        style={{
          position: "absolute",
          width: 360,
          height: 360,
          top: "30%",
          left: "40%",
          transform: "translate(-50%, -50%)",
          borderRadius: "55% 45% 65% 35% / 45% 55% 35% 65%",
          background: `radial-gradient(ellipse at center, ${GOLD}12 0%, transparent 70%)`,
          filter: "blur(40px)",
          animation: "blobMorph3 18s ease-in-out infinite alternate",
        }}
      />

      {/* Grid overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `linear-gradient(rgba(201,168,76,0.04) 1px, transparent 1px),
                            linear-gradient(90deg, rgba(201,168,76,0.04) 1px, transparent 1px)`,
          backgroundSize: "60px 60px",
          maskImage: "radial-gradient(ellipse 80% 80% at 50% 50%, black 40%, transparent 100%)",
          WebkitMaskImage: "radial-gradient(ellipse 80% 80% at 50% 50%, black 40%, transparent 100%)",
        }}
      />

      <style>{`
        @keyframes blobMorph1 {
          0%   { border-radius: 60% 40% 70% 30% / 50% 60% 40% 50%; transform: scale(1) rotate(0deg); }
          50%  { border-radius: 30% 70% 40% 60% / 60% 40% 70% 30%; transform: scale(1.08) rotate(8deg); }
          100% { border-radius: 50% 50% 30% 70% / 40% 60% 50% 50%; transform: scale(0.95) rotate(-5deg); }
        }
        @keyframes blobMorph2 {
          0%   { border-radius: 40% 60% 30% 70% / 60% 40% 70% 30%; transform: scale(1) rotate(0deg); }
          50%  { border-radius: 70% 30% 60% 40% / 30% 70% 40% 60%; transform: scale(1.1) rotate(-10deg); }
          100% { border-radius: 55% 45% 70% 30% / 50% 50% 60% 40%; transform: scale(0.92) rotate(6deg); }
        }
        @keyframes blobMorph3 {
          0%   { border-radius: 55% 45% 65% 35% / 45% 55% 35% 65%; transform: translate(-50%,-50%) scale(1); }
          50%  { border-radius: 40% 60% 45% 55% / 60% 40% 65% 35%; transform: translate(-50%,-50%) scale(1.15); }
          100% { border-radius: 65% 35% 55% 45% / 35% 65% 45% 55%; transform: translate(-50%,-50%) scale(0.9); }
        }
      `}</style>
    </div>
  );
}
